// Обработчик для session.switch_error
// Направление: server -> client
import emitter from "../../core/wsEmitter";

// Сервер не смог переключить сессию (не найдена / чужая / внутренняя ошибка).
// Толерантное завершение ожидания waitForSessionSwitch выполняется в
// session.service.ts — здесь только наблюдаемость.
emitter.on("session.switch_error", (data: any) => {
	console.warn("Session switch failed:", data?.message ?? data);
});
